import ImageFallback from 'Components/imagefallback'
import vars from 'Consts/vars'

const Mobile = (props) => {
  return (
    <div className="author-card">
      <div className="author-cover-img">
        <div className="author-image-wrapper">
          <ImageFallback
            width={50}
            height={50}
            fallbackSrc={vars.imageBrokenDefault.user}
            src={props.author_image}
            className="author-image"
            alt={props.author_name}
          />
        </div>
      </div>
      <div className="author-text-wrapper">
        <p className="author-name">{props.author_name}</p>
        <p className="author-description">{props.author_description}</p>
      </div>
      <style jsx>
        {`
          .author-card {
            display: flex;
            font-family: Roboto, sans-serif;
            flex-flow: column;
            justify-content: center;
            align-items: center;
          }

          .author-card p {
            margin: 0;
          }

          .author-cover-img {
            width: 50px;
            height: 50px;
            flex-shrink: 0;
          }

          .author-card .author-image-wrapper {
            border-radius: 50%;
            height: 100%;
            width: 100%;
            background-color: #efefef;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow-x: auto;
            flex-shrink: 0;
          }

          .author-card .author-image {
            max-width: 100%;
            max-height: 100%;
          }

          .author-card .author-text-wrapper {
            max-width: unset;
          }

          .author-card .author-name {
            font-family: Josefin Sans, sans-serif;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
            letter-spacing: -5%;
            margin: 16px 0 10px 0;
            color: #000;
            text-align: center;
          }

          .author-card .author-description {
            font-size: 14px;
            line-height: 24px;
            color: #454f5b;
            text-align: center;
          }
        `}
      </style>
    </div>
  )
}

export default Mobile
